module.exports = __webpack_public_path__ + "img/news_01.6f8e0d51.jpg";